import { Expression, NamedColumn, SqlOptions } from '../../../types';
import futureDateHandler from './future-date-handler';
import overdueHandler from './overdue-handler';
import noLinkedTasksHandler from './no-linked-tasks-handler';
import linkedTasksHandler from './linked-tasks-handler';
import completedTasksHandler from './completed-tasks-handler';

export default function customHandlers(
  column: NamedColumn, expression: Expression, sqlOptions: SqlOptions,
): Expression | null {
  const { value } = expression;
  const checkedValue = typeof value[0] === 'object' ? value[0].value : value[0];

  if (!checkedValue) {
    return null;
  }

  switch (checkedValue.toLowerCase()) {
    case 'overdue':
      return overdueHandler(column, expression);
    case 'next 7 days':
      return futureDateHandler(7, column, expression);
    case 'next 30 days':
      return futureDateHandler(30, column, expression);
    case 'no tasks':
      return noLinkedTasksHandler(column, expression);
    case 'all completed tasks':
      return completedTasksHandler(column, expression, sqlOptions);
    case 'at least 1 task':
      return linkedTasksHandler(column, expression);
    default:
      return null;
  }
}
